"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SounditiApi_1 = __importDefault(require("../SounditiApi"));

var Auth_1 = __importDefault(require("../Auth"));

var defaults_1 = __importDefault(require("../defaults"));

var logger_1 = __importDefault(require("../utils/logger"));

var errors_1 = require("../utils/errors");

var utils_1 = require("../utils/utils");

var logger = logger_1.default('campaign-access');

var PanelAccess = function () {
  /**
   *
   * @param {DataLayerConfiguration} options
   * @param {token} [options.token = ''] | An access token
   * @param {host} [options.hosts = defaults.host] | An access token
   *
   */
  function PanelAccess(_a) {
    var _b = (_a === void 0 ? {} : _a).hosts,
        hosts = _b === void 0 ? defaults_1.default : _b;
    this._authRenewal = utils_1.tokenRenewal;
    this.auth = new Auth_1.default({
      auth_host: hosts.auth_host
    });
    this.token = this.auth.getToken() || '';
    this.api = new SounditiApi_1.default({
      token: this.token,
      hosts: hosts
    });
  }
  /**
   * Gets statistics of new users created between a date range
   *
  * @param {string} sinceDAte date from which you want to make the query
  * @param {string} untilDate date until which you want to make the query
  * @example
  * format data "2021-06-15"
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<NewUsers>} An object with the following information: numDays, endDate, beginDate, newUsers
   *
   * @throws {PermissionError} 403 responses or bad token
   * @throws {Error} 40X General error
   */


  PanelAccess.prototype.getUsersCreated = function (sinceDate, untilDate, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, result, res_1, users, e, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 11,, 12]);

            return [4
            /*yield*/
            , this.api.getUsersCreated(sinceDate, untilDate)];

          case 1:
            res = _a.sent();
            if (!res.ok) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            result = _a.sent();
            logger.debug('getUsersCreated from API', __assign({}, result));
            return [2
            /*return*/
            , result];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.api.getUsersCreated(sinceDate, untilDate)];

          case 5:
            res_1 = _a.sent();
            return [4
            /*yield*/
            , res_1.json()];

          case 6:
            users = _a.sent();
            return [2
            /*return*/
            , users];

          case 7:
            if (!(res.status === 400)) return [3
            /*break*/
            , 9];
            return [4
            /*yield*/
            , res.json()];

          case 8:
            e = _a.sent();
            logger.error('getUsersCreated status 400', {
              e: e
            });
            throw new errors_1.NotFoundError(e.message);

          case 9:
            throw new errors_1.PermissionError('Invalid access token');

          case 10:
            return [3
            /*break*/
            , 12];

          case 11:
            error_1 = _a.sent();
            logger.error('Error getUsersCreated', {
              msg: error_1.message,
              name: error_1.name
            });
            throw new Error(error_1.message);

          case 12:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Gets stats of new users and their campaigns between a date range
   *
  * @param {string} sinceDAte date from which you want to make the query
  * @param {string} untilDate date until which you want to make the query
  * @example
  * format data "2021-06-15"
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<NewUsersCampaigns>} An object with the following information: numDays, endDate, beginDate, newUsers, campaignsCreatedByNewUsers, enrolledTestersInCampaignsCreatedByNewUsers
   *
   * @throws {PermissionError} 403 responses or bad token
   * @throws {Error} 40X General error
   */


  PanelAccess.prototype.getCampaignsByNewUsers = function (sinceDate, untilDate, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, result, res_2, users, e, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 11,, 12]);

            return [4
            /*yield*/
            , this.api.getCampaignsByNewUsers(sinceDate, untilDate)];

          case 1:
            res = _a.sent();
            if (!res.ok) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            result = _a.sent();
            logger.debug('getCampaignsByNewUsers from API', __assign({}, result));
            return [2
            /*return*/
            , result];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.api.getUsersCreated(sinceDate, untilDate)];

          case 5:
            res_2 = _a.sent();
            return [4
            /*yield*/
            , res_2.json()];

          case 6:
            users = _a.sent();
            return [2
            /*return*/
            , users];

          case 7:
            if (!(res.status === 400)) return [3
            /*break*/
            , 9];
            return [4
            /*yield*/
            , res.json()];

          case 8:
            e = _a.sent();
            logger.error('getCampaignsByNewUsers status 400', {
              e: e
            });
            throw new errors_1.NotFoundError(e.message);

          case 9:
            throw new errors_1.PermissionError('Invalid access token');

          case 10:
            return [3
            /*break*/
            , 12];

          case 11:
            error_2 = _a.sent();
            logger.error('Error getCampaignsByNewUsers', {
              msg: error_2.message,
              name: error_2.name
            });
            throw new Error(error_2.message);

          case 12:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Creates action for posterior analisys and data visualization
   *
   * It never throws as we only want to put data on the server
   *
   * @param {string} type The type of action
   * @param {string} screen The screen where postAction was called
   * @param {string} device The device type: mobile or desktop
   * @param {string} browser The browser used
   * @param {string} sessionId The session identifier
   * @param {string} createdAt The timestamp when the action was created
   *
   * @returns {Promise<NewActionResponse>} TODO: should return nothing in production.
   *
   * @throws {NotValidAction} When trying to post an action not defined by the backend.
   */


  PanelAccess.prototype.postAction = function (type, screen, device, browser, sessionId, createdAt) {
    if (device === void 0) {
      device = null;
    }

    if (browser === void 0) {
      browser = null;
    }

    if (sessionId === void 0) {
      sessionId = null;
    }

    if (createdAt === void 0) {
      createdAt = null;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, action, error_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);

            return [4
            /*yield*/
            , this.api.postPanelAction(type, screen, device, browser, sessionId, createdAt)];

          case 1:
            res = _a.sent();
            return [4
            /*yield*/
            , res.json()];

          case 2:
            action = _a.sent();

            if (action.created === false) {
              throw new errors_1.NotValidAction(action.newAction.message);
            }

            return [2
            /*return*/
            , action];

          case 3:
            error_3 = _a.sent();
            throw error_3;

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  return PanelAccess;
}();

exports.default = PanelAccess;